import { useEffect, useState } from "react";
import { Download, Share, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const KEY = "orbis_site_install_dismissed";
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream;

/** "Install app" banner for /m/site: native prompt on Android/desktop Chrome, step hint on iOS Safari. */
export function InstallHint({ t }) {
  const [prompt, setPrompt] = useState(window.__orbisInstallPrompt || null);
  const [hidden, setHidden] = useState(() => standalone() || localStorage.getItem(KEY) === "1");
  useEffect(() => { const h = () => setPrompt(window.__orbisInstallPrompt); window.addEventListener("orbis-installable", h); return () => window.removeEventListener("orbis-installable", h); }, []);
  if (hidden || (!prompt && !isIOS())) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  const install = async () => { prompt.prompt(); const r = await prompt.userChoice; if (r.outcome === "accepted") setHidden(true); window.__orbisInstallPrompt = null; setPrompt(null); };
  return <div className="border border-primary/40 rounded-lg bg-primary/10 p-3 text-xs flex items-start gap-3" data-testid="install-hint">
    <Download className="h-4 w-4 mt-0.5 shrink-0" />
    <div className="flex-1 space-y-1">
      <div className="font-medium">{t("cst.install.title")}</div>
      {prompt ? <Button size="sm" className="h-7" data-testid="install-app-btn" onClick={install}>{t("cst.install.button")}</Button>
        : <div data-testid="install-ios-steps">{t("cst.install.ios")} <Share className="inline h-3 w-3" /> → {t("cst.install.ios2")}</div>}
    </div>
    <button data-testid="install-dismiss" onClick={dismiss} aria-label="close"><X className="h-4 w-4" /></button>
  </div>;
}
